import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {DropdownService} from "../../../services/dropdown.service";
import {IncidentService} from "../../../services/incident.service";
import {icJWT_Account, IncidentRecord, LabInfo} from "../../../NIBINInterface";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {ReportService} from "../../../services/report.service";
import {AuthService} from "../../../services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {DownloadService} from "../../../services/download.service";
import {NewIncidentFormComponent} from "../new-incident-form/new-incident-form.component";
import {DataChangeRequestService} from "../../../services/DataChangeRequest.service";
import {GridComponent} from "@syncfusion/ej2-angular-grids";
import Swal from "sweetalert2";
import {DetailChangeHistoryComponent} from "../../detail/detail-change-history/detail-change-history.component";
import {ChangeHistoryViewComponent} from "../../detail/change-history-view/change-history-view.component";
import {ComposeEmailComponent} from "../../email/compose-email/compose-email.component";
import {ComposeEmailShareEditComponent} from "../../email/compose-email-share-edit/compose-email-share-edit.component";

@Component({
  selector: 'app-view-incidents-tbl',
  templateUrl: './view-incidents-tbl.component.html',
  styleUrls: ['./view-incidents-tbl.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [DropdownService, IncidentService, ReportService, DownloadService, DataChangeRequestService]
})
export class ViewIncidentsTblComponent implements OnInit {
  user: icJWT_Account = <icJWT_Account>{};

  dataSource2: IncidentRecord[] = []

  @Input('Incidents') set incidents(incidents: IncidentRecord[]) {
    this.dataSource2 = incidents
  }
  @Input("showAdd") showAdd:boolean = true;
  @Output('SelectedEvent') SelectedEvent = new EventEmitter<IncidentRecord>();
  @Output('TriggerReload') TriggerReload = new EventEmitter<boolean>();

  constructor(private authService: AuthService,private downloadService: DownloadService, public dialog: MatDialog, private incidentService:IncidentService, private dataChangeRequestService:DataChangeRequestService, private dropdownService: DropdownService) {
    this.user = this.authService.getUser()
  }

  ngOnInit(): void {}

  SelectedForReport(incident:IncidentRecord) {
    this.SelectedEvent.emit(incident)

  }

  editIncidentDialog(incident:IncidentRecord) {
    let dia = this.dialog.open(NewIncidentFormComponent, {
      width: '80%',
      height: '80%',

    })

    dia.componentInstance.data=this.incidentService.prepareEditIncident(incident);

    dia.componentInstance.IncidentCreated.subscribe((val)=>{

      this.incidentService.saveEditIncToDB(val).then(r=>{
        dia.close();
        Swal.fire({
          icon: 'success',
          title: 'System Notification',
          text: "Successfully Saved Changes to Incident Record",
          timerProgressBar:true,
          timer:4000
        })
        incident=r; //replace obj with updated object
        this.TriggerReload.emit(true)
      })

    })

  }

  viewNIBINReport(ReportID: string) {
    this.downloadService.DownloadNIBINReport(ReportID)
  }
  viewNJPOPReport(NJPOPno: string) {
    this.downloadService.DownloadNJPOPReport(NJPOPno)
  }

  viewNIBINBallisticsReport(IncidentID: any) {
    this.downloadService.DownloadBallisticsReport(IncidentID)
  }

  async TransferOwnership(incident:any) {
    let labs:LabInfo[] = await this.dropdownService.getLabsList()
    let IncidentID:string = incident.IncidentID
    let labsSelectOptions:string = ""

    for(let l of labs){
      labsSelectOptions+='<option value="'+l.LAB_SN+'">'+l.LAB_FN+'</option>'
    }
    const {value: TOReq} = await Swal.fire({
      title: 'Transfer Ownership to New Lab',
      html:
        `<label for="TO_Lab">Choose a Lab:</label><br />
        <select name="TO_Lab" id="TO_Lab" > <option value="">--Select A Lab--</option>
            `+ labsSelectOptions +`
        </select>
        ` +
        '<br /><label for="TO_Reason">Transfer Reason:</label><br /> <Textarea id="TO_Reason" ></Textarea>',
      focusConfirm: false,
      showCancelButton: true,
      width:'500px',
      preConfirm: () => {
        return {
          LAB:(<HTMLInputElement>document.getElementById('TO_Lab')).value,
          REASON:(<HTMLInputElement>document.getElementById('TO_Reason')).value
        }
      }
    })

    if (TOReq) {

      if(!TOReq.LAB.trim() || !TOReq.REASON.trim()){
        Swal.fire({
          icon: 'error',
          title: 'System Notification',
          text: "Transfer Ownership Request has been Rejected. Missing Lab and/or Reason",
          timerProgressBar:true,
          timer:4000
        })
      }else{

        this.dataChangeRequestService.ChangeLab(IncidentID,TOReq.LAB?TOReq.LAB:this.user.CurrentDept, TOReq.REASON).then((r)=>{
          Swal.fire({
            icon: 'success',
            title: 'System Notification',
            text: "Transfer Ownership Request has been Sent.",
            timerProgressBar:true,
            timer:4000
          })

        })
      }

    }

  }

  async ViewIncidentChangeHistory(incident: any) {
    let inc: IncidentRecord[] = await this.incidentService.getIncident(incident.IncidentID);
    console.log(inc)
    let dia = this.dialog.open(ChangeHistoryViewComponent, {
      width: '90%',
      height: '90%',
      disableClose: false
    })

    if(inc && inc.length>0 && inc[0].ChangeHistory)
      dia.componentInstance.ChangeHistoryList= inc[0].ChangeHistory;

  }

  DeleteIncident(incident: any) {
    Swal.fire({
      title: 'Are you sure you want to delete this incident?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        this.incidentService.deleteIncident(incident).then(r => {
          Swal.fire({
            icon: 'success',
            title: 'System Notification',
            text: "Incident has been Successfully Deleted.",
            timerProgressBar:true,
            timer:4000
          })
        })
      }
    })
  }

  ShareEditLink(incident: any) {
    if(incident.IncidentID){

      let ref = this.dialog.open(ComposeEmailShareEditComponent, {
        width: '60%',
        height: '80%'
      })
      ref.componentInstance.incidentRecord = incident;

      ref.componentInstance.SentEvent.subscribe((val)=>{
        ref.close();
      })


      /*Swal.fire({
        icon: 'question',
        title: 'Request Update via Email',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
          placeholder:'Enter Email Address'
        },
        showCancelButton: true,
        confirmButtonText: 'Send',
        showLoaderOnConfirm: true,
        preConfirm: (email) => {
          console.log(email)
          this.dataChangeRequestService.getSharedEditLink(incident.IncidentID, email).then(r => {
            if(r.AnyData){
              Swal.fire({
                icon: 'success',
                title: 'Request Email Sent',
                //text: document.location.origin+"/request?hID="+r.AnyData,
                timerProgressBar:true,
                timer:4000
              })
            }
          })
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        console.log(result)
      })*/

    }

  }
}
